export default "__VITE_ASSET__15196e94__"